import { render, staticRenderFns } from "./GroupCommentBus.vue?vue&type=template&id=8bf56c7c"
import script from "./GroupCommentBus.vue?vue&type=script&lang=js"
export * from "./GroupCommentBus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports